var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33.2157C5 27.0214 9.92857 22 20 22C30.0714 22 35 27.0214 35 33.2157C35 34.2011 34.3153 35 33.4706 35H6.52941C5.68474 35 5 34.2011 5 33.2157Z",
    fill: "url(#paint0_linear_387_300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12C26 15.3137 23.3137 18 20 18C16.6863 18 14 15.3137 14 12C14 8.68629 16.6863 6 20 6C23.3137 6 26 8.68629 26 12Z",
    fill: "url(#paint1_linear_387_300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_387_300",
    x1: 29,
    y1: 10.5,
    x2: 29.8179,
    y2: 46.6649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4965A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_387_300",
    x1: 29,
    y1: 10.5,
    x2: 29.8179,
    y2: 46.6649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5C9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4965A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.4570a8ce75996d29c72bb91a576d3fe5.svg";
export { ForwardRef as ReactComponent };